import LangEnum from '../../../../lang/LangEnum';
import { LangEnumOption } from '../../../../lib/OptionsLib';

export enum OrderGatewayPaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
  REFUNDED = 'REFUNDED',
  WAITING_REFUND = 'WAITING_REFUND',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export const orderGatewayPaymentStatusLabel: Record<OrderGatewayPaymentStatus, LangEnum> = {
  [OrderGatewayPaymentStatus.PENDING]: LangEnum.PAYMENT_LINK_STATUS_CREATED,
  [OrderGatewayPaymentStatus.PAID]: LangEnum.PAYMENT_LINK_STATUS_PAID,
  [OrderGatewayPaymentStatus.EXPIRED]: LangEnum.PAYMENT_LINK_STATUS_EXPIRED,
  [OrderGatewayPaymentStatus.CANCELED]: LangEnum.PAYMENT_LINK_STATUS_CANCELED,
  [OrderGatewayPaymentStatus.ERROR]: LangEnum.GLOBAL_ERROR,
  [OrderGatewayPaymentStatus.REFUNDED]: LangEnum.PAYMENT_LINK_STATUS_REFUNDED,
  [OrderGatewayPaymentStatus.WAITING_REFUND]: LangEnum.PAYMENT_LINK_STATUS_REFUND_IN_ANALYSIS,
  [OrderGatewayPaymentStatus.PAYMENT_FAILED]: LangEnum.PAYMENT_LINK_STATUS_ERROR,
};

export const orderGatewayPaymentStatusColor: Record<OrderGatewayPaymentStatus, string> = {
  [OrderGatewayPaymentStatus.PENDING]: '#9E9E9E',
  [OrderGatewayPaymentStatus.PAID]: '#00CBA1',
  [OrderGatewayPaymentStatus.EXPIRED]: '#242424',
  [OrderGatewayPaymentStatus.CANCELED]: '#242424',
  [OrderGatewayPaymentStatus.ERROR]: '#D32F2F',
  [OrderGatewayPaymentStatus.REFUNDED]: '#242424',
  [OrderGatewayPaymentStatus.WAITING_REFUND]: '#3366FF',
  [OrderGatewayPaymentStatus.PAYMENT_FAILED]: '#D32F2F',
};

export const orderGatewayPaymentStatusOptions: Array<LangEnumOption> = [
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.PENDING],
    value: OrderGatewayPaymentStatus.PENDING,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.PAID],
    value: OrderGatewayPaymentStatus.PAID,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.CANCELED],
    value: OrderGatewayPaymentStatus.CANCELED,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.REFUNDED],
    value: OrderGatewayPaymentStatus.REFUNDED,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.EXPIRED],
    value: OrderGatewayPaymentStatus.EXPIRED,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.WAITING_REFUND],
    value: OrderGatewayPaymentStatus.WAITING_REFUND,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.PAYMENT_FAILED],
    value: OrderGatewayPaymentStatus.PAYMENT_FAILED,
  },
  {
    label: orderGatewayPaymentStatusLabel[OrderGatewayPaymentStatus.ERROR],
    value: OrderGatewayPaymentStatus.ERROR,
  },
];
